import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import $ from 'jquery';

export default class Hero extends React.Component {
  state = {
    isOpen: false,
    isMounted: false,
    executed: false,
    willUnmount: false,
  };
  handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  componentDidMount() {
    $('.mousey').addClass('showUpMousey');
    console.log('mounts');
    setTimeout(
      function () {
        this.setState((prevState) => ({ isMounted: !prevState.isMounted }));
      }.bind(this),
      0
    );
  }

  componentDidUpdate() {
    this.changeHero();
  }

  componentWillUnmount() {
    this.setState({ willUnmount: true });
    clearInterval(window.myInterval);
  }

  changeHero() {
    let images = [
      'https://nabytekbatka.cz/venekW.jpg',
      'https://nabytekbatka.cz/kuchyne/modra.jpg',
      'https://nabytekbatka.cz/hneda.jpg',
    ];

    let heroContainer = document.getElementById('her');

    if (
      !this.state.willUnmount &&
      $(window).width() > 1441 &&
      !this.state.executed
    ) {
      this.setState({ executed: true });

      let i = 0;

      window.myInterval = setInterval(function () {
        $('#her').removeClass('showUp');
        setTimeout(function () {
          heroContainer.style.background =
            'linear-gradient( rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25) ), url(' +
            images[i] +
            ') no-repeat';
          heroContainer.style.backgroundPosition = 'center bottom';
          if ($(window).width() > 1441) {
            heroContainer.style.backgroundSize = '130%';
          } else {
            heroContainer.style.backgroundSize = '180%';
          }

          $('#her').addClass('showUp');
        }, 500);

        i++;
        if (i === images.length) {
          i = 0;
        }
      }, 5000); // konec intervalu
    }
  }

  render() {
    return (
      <div>
        <nav
          className={
            this.state.isMounted ? 'navbar desktop slideDown' : 'navbar desktop'
          }
        >
          <div className="navbar-container">
            <div className="logo-container">
              <Link to="/">
                <img
                  className="logo"
                  src="https://www.nabytekbatka.cz/logo.svg"
                  alt="logo"
                ></img>
              </Link>
              <button type="button" className="nav-btn">
                <FaBars onClick={this.handleToggle} className="nav-icon" />
              </button>
            </div>
            <ul
              className={this.state.isOpen ? 'nav-links show-nav' : 'nav-links'}
            >
              <li className="menu-item">
                <a
                  onClick={this.handleToggle}
                  className="scroll"
                  href="#services"
                >
                  služby
                </a>
              </li>
              <li className="menu-item">
                <a
                  className="scrol"
                  href="#portfolio"
                  onClick={this.handleToggle}
                >
                  reference
                </a>
              </li>
              <li className="menu-item">
                <a className="scroll" href="#about" onClick={this.handleToggle}>
                  o nás
                </a>
              </li>
              <li className="menu-item">
                <a
                  className="scroll menu-contact-btn"
                  href="#contact"
                  onClick={this.handleToggle}
                >
                  kontakt
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div
          id="her"
          className={
            this.state.isMounted
              ? 'hero-container parallax--bg showUp'
              : 'hero-container parallax--bg'
          }
        >
          <hr className="hero-hr"></hr>
          <h1
            className={
              this.state.isMounted ? 'hero-title slideDownT' : 'hero-title'
            }
          >
            Moderní interiéry <span>na míru</span>, <br></br>podle vašich
            představ
          </h1>
          <p className="hero-text">
            Už skoro 20 let vyrábíme nábytek a vysněné interiéry. Určitě spolu
            taky něco vymyslíme.
          </p>
          <div className="kafe">
            <p className="kafe-text">Stavte se na kafe!</p>
            <a href="#contact" className="scrol">
              <button className="kafe-btn">kontakt</button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero.js